// extracted by mini-css-extract-plugin
export default {"exceededWrapper":"PunchupPoolTile_exceededWrapper__B36wm punchupExceededRing","warningIcon":"PunchupPoolTile_warningIcon__OaaIf"};